import { lazy, Suspense } from 'react'

const ConnectedAssignmentsViewWithProvider = lazy(
  () => import('./AssignmentsViewWithProvider')
)

export const ConnectedAssignmentsView: React.VFC = (props) => (
  <Suspense fallback={null}>
    <ConnectedAssignmentsViewWithProvider {...props} />
  </Suspense>
)
